module.exports = __webpack_public_path__ + "img/img_nav_vip-w.536f0686.svg";